// extracted by mini-css-extract-plugin
export default {"team":"Team_team__xXab6","frame":"Team_frame__b8OI7"};